import { QueryFunction, useQuery, UseQueryResult } from 'react-query'
import { AxiosError } from 'axios'

import { Company } from 'common/interfaces'
import { useHeapDispatch } from 'context/Heap'

import api from './api'
import { getCompanySlug } from './flow'

const getCompany: QueryFunction<Company, ['company', string]> = async ({ queryKey }) => {
  const [, companySlug] = queryKey

  const response = await api.get<Company>(`companies/${companySlug}/`)

  return response.data
}

const useCompany = (): UseQueryResult<Company, AxiosError> => {
  const company = getCompanySlug()

  const [heapDispatch] = useHeapDispatch()

  const query = useQuery<Company, AxiosError>(['company', company], getCompany, {
    onSuccess: ({
      terms_and_conditions_link: termsLink,
      name,
      privacy_policy_link: privacyLink,
      support_email: supportEmail,
    }) => {
      heapDispatch({
        type: 'add',
        fields: {
          company: {
            name,
            supportEmail,
            termsLink,
            privacyLink,
          },
        },
      })
    },
  })
  return query
}

export { useCompany }
